
<div class="dg-modal-header">
    <h2>{{popupTitle}}</h2>
    <i (click)="action(false)" class="close-icon icon-cross_16px"></i>
</div>

<div class="dg-modal-body">

    <span>Please select a new delivery location in the field below.</span>

    <div class="delivery-location">

        <b>Delivery location</b>
        <div class="dropdown-block">
            <div class="head" (click)="toggle()">
                <span [class.empty]="!newDeliveryLocation.key">{{newDeliveryLocation.value || 'Select'}}</span>
                <i class="icon-arrow-expand arrow-icon" [class.opened]="isLocationDropdownOpen"></i>
            </div>
                <div *ngIf="isLocationDropdownOpen" class="list">
                    <div class="search-wrapper" >
                        <div class="search-section">
                            <input type="text"
                                [(ngModel)]="filterQuery"
                                (ngModelChange)="setFilterQuery($event)"
                                placeholder="Search"
                                maxlength="50"
                                (focus)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()">
                            <i class="icon-search"></i>
                            <button id="clear-filter-search"
                                appTrackClickButton
                                type="button"
                                class="icon-cross_16px clear-control"
                                [hidden]="!filterQuery.length"
                                (click)="$event.stopPropagation(); setFilterQuery('')">
                            </button>
                        </div>
                    </div>

                    <ng-container *ngTemplateOutlet="hasFilteredResults ? optionsList : emptyList"></ng-container>

                    <ng-template #optionsList>
                        <div class="options-wrapper">
                            <div *ngFor="let option of deliveryLocationOptions | listFilter: filterBy : false"
                            class="option"
                            (click)="locationChanged(option); toggle()">

                                <div class="option-label">
                                    <span [innerHTML]="option.value | htmltransfrom | highlight: pipeFilterQuery"></span>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #emptyList>
                        <div class="options-empty">No delivery locations found</div>
                    </ng-template>
                </div>
            </div>
        </div>
</div>
<div class="dg-modal-footer">
    <button
        (click)="action(false)"
        appTrackClickButton
        id="dismiss"
        type="button"
        class="button secondary"
        >{{ buttonsTitle.dismiss }}
    </button>

    <button
        (click)="submit()"
        [disabled]="!newDeliveryLocation.key"
        appTrackClickButton
        id="dismiss"
        type="button"
        class="button primary"
        >{{ buttonsTitle.confirm }}
    </button>
</div>
